import React, { useState } from "react";
import api from "../services/api";
import { setToken } from "../ auth";                
import { useNavigate, Link } from "react-router-dom";
import NavBar from "../components/navbar/navbar";
import { useTranslation } from "react-i18next";   
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";

export default function LoginPage() {
  const { t } = useTranslation();                  
  const [login, setLogin] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    try {
      const res = await api.post("/auth/login", { login, password });
      const { token, user } = res.data;
      setToken(token);

      switch (user.role) {
        case "aspirant":
          navigate("/dashboard");
          break;
        case "coordinateur_district":
          navigate("/dashboard-district");
          break;
        case "coordinateur_region":
          navigate("/dashboard-region");
          break;
        case "admin":
          navigate("/admin");
          break;
        case "eglise":
          navigate("/dashboard-eglise");
          break;
        default:
          alert(t("role_unknown"));
      }
    } catch (err) {
      console.error("Erreur de connexion:", err);
      // Afficher le message d'erreur spécifique du serveur ou un message par défaut
      const errorMessage = err?.response?.data?.error || err?.message || t("login_error");
      setError(errorMessage);
    }
  };

  return (
    <div>
      <NavBar />

      <div className="min-vh-100 d-flex align-items-center justify-content-center bg-body-secondary">
        <style>{`
          .login-card { max-width: 420px; border-radius: 15px; }
          .form-control:focus { box-shadow: 0 0 0 0.2rem rgba(13,110,253,.25); }
          .login-title { font-weight: 600; }
        `}</style>

        <div className="card login-card shadow p-4 border-0 bg-white w-100">
          <div className="text-center mb-4">
            <i className="bi bi-lock-fill text-primary" style={{ fontSize: "2rem" }} />
            <h3 className="text-primary login-title mt-2">{t("login_title")}</h3>
            <p className="text-muted">{t("login_subtitle")}</p>
          </div>

          {error && <div className="alert alert-danger">{error}</div>}

          <form onSubmit={handleSubmit}>
            {/* Login */}
            <div className="mb-3">
              <label className="form-label" htmlFor="login">{t("login_label")}</label>
              <input
                id="login"
                type="text"
                className="form-control"
                placeholder={t("login_placeholder")}
                value={login}
                onChange={(e) => setLogin(e.target.value)}
                required
                autoComplete="username"
              />
            </div>

            {/* Password */}
            <div className="mb-3">
              <label className="form-label" htmlFor="password">{t("password_label")}</label>
              <div className="position-relative">
                <input
                  id="password"
                  type={showPassword ? "text" : "password"}
                  className="form-control"
                  placeholder={t("password_placeholder")}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                  autoComplete="current-password"
                  style={{ paddingRight: "40px" }}
                />
                <button
                  type="button"
                  className="btn btn-link position-absolute end-0 top-50 translate-middle-y"
                  style={{ 
                    border: "none", 
                    background: "none", 
                    padding: "0 10px",
                    color: "#6c757d",
                    textDecoration: "none"
                  }}
                  onClick={() => setShowPassword(!showPassword)}
                  aria-label={showPassword ? "Masquer le mot de passe" : "Afficher le mot de passe"}
                >
                  <i className={`bi ${showPassword ? "bi-eye-slash" : "bi-eye"}`} style={{ fontSize: "1.2rem" }} />
                </button>
              </div>
            </div>

            {/* Remember + Forgot */}
            <div className="d-flex justify-content-between align-items-center mb-3">
              <div className="form-check">
                <input className="form-check-input" type="checkbox" id="remember" />
                <label className="form-check-label" htmlFor="remember">
                  {t("remember_me")}
                </label>
              </div>
              {/* Remplacer par la route réelle si différente */}
              <Link to="/forgot-password" className="text-decoration-none small text-primary">
                {t("forgot_password")}
              </Link>
            </div>

            <button type="submit" className="btn btn-primary w-100">
              <i className="bi bi-box-arrow-in-right me-2" />
              {t("login_button")}
            </button>
          </form>

          <div className="text-center mt-4">
            <p className="mb-0">
              {t("no_account")}{" "}
              <Link to="/register" className="text-decoration-none text-primary">
                {t("register_link")}
              </Link>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
